/**
 * @preserve C.A.S. master JS file
 * Copyright (C) 2016-2019 Software Consulting Services, LLC.
 */

"use strict";

/**
 * Transforms an element into a loading element and returns a callback to restore its original state
 * @param selector - JQuery selector for the element to transform
 * @param append - option to append loading icon to old html rather than replace
 * @returns callback function which will restore the original element
 */
function startLoadingButton(selector, append = false) {
  const oldHTML = $(selector).html();
  $(selector).html(`${append ? oldHTML :""}<span class="spinner-border spinner-border-sm" style="margin-top: 3px; ${append ? "margin-left: 5px" : ""}"></span>`);
  $(selector).attr("disabled", "disabled");
  return (newHTML) => {
    $(selector).removeAttr("disabled");
    $(selector).html(newHTML ?? oldHTML);
  };
}

var helpJSON = undefined

//******************
//! UI helpers
//******************
// Modal dialogs
function modalM(mtitle, mbody, mbutton1, mExtraButtons, mcallback, mclass, mConfirmCloseOptions={ mConfirmClose : false, }, extraCallback) {
  if (!mtitle)
    mtitle = "";
  if (!mbutton1)
    mbutton1 = "Close";

  var $modal = $(document.getElementById("modalM").outerHTML);

  // Generate a unique ID for this modal. That way we can remove it when it is closed.
  const uniqueID = setUniqueId($modal);
  $modal.find('.modal-title').text(mtitle);
  $modal.find('.modal-body').empty();
  $modal.find('.modal-body').html(mbody);
  if (mclass)
    $modal.find('.modal-dialog').addClass(mclass);

  $("#contentContainer").append($modal);

  var $footer = $modal.find('div.modal-footer'),
      $mbtn1 = $footer.find('button[name=mbtn1]'),
      $mbtn2 = $footer.find('button[name=mbtn2]'),
      $header = $modal.find('.modal-header');
  $mbtn1.text(mbutton1);

  if (typeof mExtraButtons == "string") {
    // String option left for compatability
    $mbtn1.addClass("btn-primary");
    $mbtn1.removeClass("btn-default");
    $mbtn2.text(mExtraButtons);
    $mbtn2.show();
  }
  else if (typeof mExtraButtons == "object" &&
           !isUndefinedOrNull(mExtraButtons) &&
           !isUndefinedOrNull(mExtraButtons.length) &&
           mExtraButtons.length > 0) {
    $mbtn1.addClass("btn-primary");
    $mbtn1.removeClass("btn-default");
    $mbtn2.text(mExtraButtons[0]);
    $mbtn2.addClass("extraButton0")
    $mbtn2.show();
    $.each(mExtraButtons.slice(1), function(i, e) {
      var $btn = $mbtn2.clone().removeAttr("name").html(e);
      $mbtn2.removeClass("extraButton0")
      $mbtn2.addClass("extraButton" + ( i + 1 ))
      $footer.append($btn);
    });
  } else {
    $mbtn1.removeClass("btn-primary");
    $mbtn2.hide();
    // $footer.find("button:not([name])").remove();
  }
  $mbtn1.off();
  $mbtn2.off();
  $footer.find("button").click(async function (e) {
    var ret;
    $("#modalError").innerHTML = "" // clear any old errors
    if (mcallback) {
      const btn = e.currentTarget.innerHTML // get before start loading so that inner html doesn't have loading spinner
      const stopLoading = startLoadingButton(`#${uniqueID} button.${Array.from(e.currentTarget.classList).join(".")}`, true)
      try {
        ret = await mcallback(btn);
      }
      catch(e) {
        $footer.find("#modalError").html(e.message)
        stopLoading()
        return
      }
      stopLoading()
    }
    if (ret === false)
      return e.preventDefault();
    mcallback = undefined;
    $modal.modal('hide');
  });
  $modal.on('hide.bs.modal', async function(e) {
    var ret;
    if (mcallback)
      if (mcallback.constructor.name === "AsyncFunction") {
        ret = await mcallback('');
      } else {
        ret = mcallback('');
      }
    if (ret === false)
      return e.preventDefault();
    mcallback = undefined;
    return true;
  });
  $modal.on('hidden.bs.modal', function (e) {
    var ret;
    $mbtn1.off('click');
    $mbtn2.off('click');
    $modal.off('hidden.bs.modal');
    $( "#contentContainer" ).find( "#" + $modal.attr( "id" ) ).remove();
    if (mcallback)
      mcallback("X"); // wasn't dismissed via buttons
  });
  $modal.on('shown.bs.modal', function() {
    // Select primary button by default
    $mbtn1.focus();
    $mbtn1.select();
    if ( extraCallback ) {
      try {
        extraCallback();
      }
      catch ( e ) {
        console.error( "Error in extraCallback:", e );
      }
    }
  } );

  if (mConfirmCloseOptions.mConfirmClose) {
    const mConfirmCloseText = mConfirmCloseOptions.mConfirmCloseText || "Are you sure you want to close this window?";
    const mConfirmCloseButtons = mConfirmCloseOptions.mConfirmCloseButtons || ["Close"];
    $modal.modal({ keyboard: false, backdrop: false }); // Disables the default escape key action

    let closeModalEventListeners = function(e) {
      if (e.key == "Escape") {
        e.preventDefault();
        if (confirm(mConfirmCloseText)) {
          $modal.modal('hide');
        }
      }
    };

    addEventListener("keydown", closeModalEventListeners);
    $modal.find(".close").on("click", function() {
      if (confirm(mConfirmCloseText)) {
        $modal.modal('hide');
      }
    });

    for (let buttonText of mConfirmCloseButtons) {
      $footer.find("button:contains('" + buttonText + "')").click(function() {
        if (confirm(mConfirmCloseText)) {
          $modal.modal('hide');
        }
      });
    }

    $modal.on('hide.bs.modal', function() {
      removeEventListener("keydown", closeModalEventListeners);
    });
  } else {
    $header.find(".close").attr("data-bs-dismiss", "modal");
  }

  $modal.modal('show');
  doTooltips(".modal-body", "top", ".wrapper");
  return $modal;
}

/**
 * Destroys any existing modal dialogs within the content container.
 */
function destroyModals() {
  var $existingModal = $( '#contentContainer' ).find( '.modal' );
  if ( $existingModal.length ) {
    $existingModal.modal( 'hide' );
    $existingModal.remove();
  }
}

function confirmM(text, callback, options) {
  /*  You can pass the optional parameters title,
        confirm, cancel and cancelCallback in the
        options parameter.
      The title, confirm and cancel options just
        change the displayed text. cancelCallback
        is called if you hit the cancel button
        instead of confirm.
  */
  options = options || {};
  var title = options.title || 'Confirmation Required',
      confirmBtn = options.confirm || 'Yes',
      cancelBtn = options.cancel || 'No',
      cancelCallback = options.cancelCallback;
  modalM(title, text, confirmBtn, cancelBtn, async function(btn) {
    if (btn == confirmBtn && callback) {
        await callback();
    }
    else if (btn == cancelBtn && cancelCallback)
      cancelCallback();
  });
}

function confirmMAsync(text, options) {
  options = options || {};
  return new Promise((resolve)=>{
    confirmM(text, ()=>{
      resolve(true)
    }, {
      title: options.title,
      confirm: options.confirm,
      cancel: options.cancel,
      cancelCallback: ()=>{
        resolve(false)
      }
    });
  });
}

function alertM(text, title, html) {
  if (!html)
    text = $("<div/>").text(text).html();
  modalM(title, text);
}

function notify(text, context, html, time, closeOnClick) {
  /* Display a dismissable notification at the top of the screen.
        text: string, The contents of the notification
        context: string, a bootstrap alert string that can be any of the
            following: 'success', 'info', 'warning', 'error'. Defaults to 'success'
        html: boolean, whether the text is html or not
        time: integer, number of seconds before notification fades.
            Defaults to 0, which will never fade.
        closeOnClick: boolean, signals whether clicking the notification closes
            it or you have to click the X. Default is true.
  */
  context = context || 'success';
  time = time || 0;
  closeOnClick = ( closeOnClick !== false );

  var $alertContainer = $('#alert-window'),
      $alertBox = $('<div class="alert" id="alert-box"></div>'),
      $alertClose = $('<a href="#" class="close" data-bs-dismiss="alert" ' +
              'aria-label="close" title="close">×</a>');

  if (context == "error")
    context = "danger";
  else if (["warning", "info", "danger", "success"].indexOf(context) == -1)
    context = "info";

  $alertBox.addClass("alert-" + context);

  if (!html)
    text = $("<div/>").text(text).html();

  if (closeOnClick)
    $alertBox.click(function(){ $alertBox.remove() });

  if (time !== 0)
    window.setTimeout(function(){
      $alertBox.fadeOut(5000);
      window.setTimeout(function(){$alertBox.remove()}, 5000) }, time * 1000);

  $alertBox.append($alertClose).append(text);
  $alertContainer.append($alertBox);

  $alertBox.fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
  return $alertBox;
}

function isUndefinedOrNull( obj ) {
  return ( typeof obj === 'undefined' || obj === null );
}

function onInverseClick( $obj, func ) {
  var $window = $(document);
  $window.mousedown(function() {
    func();
    $window.off('mousedown');
  });
  $obj.mousedown(function(e) {
    e.stopPropagation();
  });
}

function popup($body, posX, posY, addClass, callback) {
  /* Creates a floating div at position (posX, posY) with class addClass. */
  posX = posX || 0;
  posY = posY || 0;
  $('#contentContainer').append($body);
  $body.css('position', 'absolute')
       .css('top', posY + 'px')
       .css('left', posX + 'px')
       .addClass(addClass);
  onInverseClick($body, function() {
    if (!callback || !callback()) {
      $body.remove();
    }
  });
}

function popupMenu(id, createMenu, destroyOnClose) {
  /* Creates a popup menu using onInverseClick and the optionsList supplied.
     The popup will hide after being used and won't recreate itself.
      * id is the selector id to be given to the popup menu
      * createMenu is an object with the following properties
        ~ $parent is the element to attach the popup menu to
        ~ event is a mouse event object. If passed the popup will be placed absolutly at
            clicked mouse's x and y position
        ~ The optionsList is a list of objects where each object has a title value
 title (or altTitleKey if defined) is what is displayed in the popup menu
        ~ The callback function should take at least 1 argument which will be
            the assosciated object of the element clicked
        ~ altTitleKey changes what to look for in the optionsList for the display
        ~ clickIfSingleOption (default true) will automatically click the option
            if it is the only one available
  */
  var $parent = null, callback = null, optionsList = null, altTitleKey = null,
          clickIfSingleOption = false, event = null;

  if (createMenu != undefined && createMenu != null) {
    $parent = createMenu.$parent;
    callback = createMenu.callback;
    optionsList = createMenu.optionsList;
    altTitleKey = createMenu.altTitleKey;
    clickIfSingleOption = createMenu.clickIfSingleOption;
    event = createMenu.event;
  }

  if ( !id ){
    console.error("popupMenu failed, missing menu id");
    return;
  }

  // This should not find anything if we havent created the menu yet
  var $popupMenu = $('#' + id),
      creatingPopup = $popupMenu && !$popupMenu.length,
      titleKey = altTitleKey || 'title';

  if (creatingPopup) {
    // Create menu if it isn't already there and we have an optionsList
    if (optionsList && optionsList.length) {
      $popupMenu = $('<ul class="dropdown-menu popup-menu" id="' + id + '"></ul>');

      $.each( optionsList, function(i, option) {
        var $li = $('<li ' + (option.disabled ? 'class="disabled"' : "")
          + '><a href="#">' + option[titleKey] + '</a></li>');
        $popupMenu.append($li);
        $li.click(function(e) {
          e.stopPropagation();
          e.preventDefault();
          if (option.disabled)
            return;
          if (callback)
            callback(option);
          if (destroyOnClose) {
            $popupMenu.remove()
          }
          else {
            $popupMenu.hide();
          }
        });
      });
    } else {
      // Error if no pop-up menu and no optionsList
      console.error("popupMenu failed, no popup menu to display");
      return;
    }
  }

  // Append the menu to the relevant element
  $popupMenu.css('display', 'none');
  if ($parent) {
    // Append to a parent element
    $parent.append($popupMenu);
  }
  else if (event) {
    // Append to the page but use mouse position
    $popupMenu.css('position','absolute')
      .css('left', event.pageX + 'px')
      .css('top', event.pageY + 'px');
    $('#contentContainer').append($popupMenu);
  }
  else if (!$popupMenu.parent().length) {
    // Append to window if it isn't already appended to something
    $('#contentContainer').append($popupMenu);
  }

  var $optionsList = $popupMenu.find('a');
  if (clickIfSingleOption && $optionsList.length == 1) {
    $optionsList.click();
  } else {
    $popupMenu.show();
    onInverseClick($popupMenu, function() {
      $popupMenu.hide();
    });
  }
}

var ICONS = {
  BIG_VIEWFLASH: "fa-bolt",
  BIG_VIEWJPG: "fa-file-image-o",
  BIG_VIEWPDF: "fa-file-pdf-o",
  BIG_ROUTEAD: "fa-exchange",
  BIG_FINALAD: "fa-check-square-o",
  BIG_LAUNCHAD: "fa-space-shuttle",
  BIG_OPENFOLDER: "fa-folder-open",
  BIG_PICTURE: "fa-picture-o",
  BIG_ENVELOPE: "fa-envelope",
  BIG_GREENDOWNLEFTARROW: "fa-repeat",
  BIG_ADCAT_PAGE: "fa-table",
  BIG_PICKUP: "fa-hand-paper-o",
  BIG_ADD_NEW: "fa-plus-circle",
  BIG_VIEWEIOPDF: "fa-file-text-o",
  BIG_CREATE_AD: "fa-plus-circle",
  BIG_SEND_AD_TO_PROOF: "fa-paper-plane",
  BIG_VIEW_SUBMISSIONS: "fa-clipboard",
  BIG_AD_LAYOUT_SHEET: "fa-file-text-o",
  BIG_AD_NOTES: "fa-sticky-note",
  BIG_REVISIONS: "fa-list-ul",
  BIG_PENCIL: "fa-pencil",
  BIG_GREEN_PLUS: "fa-plus",
  BIG_REDX: "fa-times",
  BIG_DISK: "fa-floppy-o",
  BIG_CANCEL: "fa-ban",
  BIG_CHECKOUT: "fa-shopping-bag",
  BIG_SCROLL: "fa-arrows-v",
  BIG_DISK_CHECK: "fa-floppy-o",
  BIG_TRANSFERAD: "fa-share",
  BIG_PRINT_EIO: "fa-print",
  BIG_CALENDAR: "fa-calendar",
  BIG_POINTER: "fa-mouse-pointer",
  BIG_RECTANGLE: "fa-square-o",
  BIG_OVAL: "fa-cicle-thin",
  BIG_LINE: "fa-minus-square",
  BIG_INTERNAL_PROOF: "fa-edit",
  BIG_DOWNLOAD: "fa-archive"
};

// Toolbars
function BuildToolbar($e, data) {
  $e.addClass("scs-toolbar");
  for (var i in data) {
    var dat = data[i],
      $btn = $('<a class="btn btn-default" draggable="false"></a>');
    $btn.on("dragstart", function () { return false; });
    if (window.innerWidth > 767)
      $btn.prop("title", dat.TOOLTIP);
    $btn.prop("id", 'tb_' + dat.ID);
    if (!dat.ENABLED) {
      // The following is the old method of doing this; but the current decision
      // is to just hide such elements rather than adding them permanently disabled.
      //$btn.attr("disabled", "disabled");
      //$btn.attr("data-server-disabled", "true");
      continue;
    }
    $btn.data("min", dat.MIN);
    $btn.data("max", dat.MAX);
    $btn.html('<i class="fa ' + ICONS[dat.ICON] + '"></i>');
    $btn.append($('<span class="visible-xs-inline"></span>').text(' ' + dat.TOOLTIP));
    $e.append($btn);
  }
}

// Custom forms
function BuildCustomForm($e, callback) {
  var ids = $e.attr("data-custom-form").split(";");
  if (!ids || ids.length != 3) {
    if (callback)
      callback();
    return;
  }
  var data = {
    command: "getadform",
    formtype: ids[0],
    formid: ids[1],
    typeid: ids[2]
  };
  var xFormData = JSON.parse($e.find("x-form-data").text());
  Command(data, function (resp) {
    if (resp.error) {
      alertM("Error loading form: " + GetError(resp));
      if (callback)
        callback();
      return;
    }
    var $form = $(resp.Form);

    var queryString = "input[name], select, label, a, span, textarea",
      props = ['id', 'name', 'for', 'value', 'class', 'readOnly', 'type'];

    // Pre-process for <span>s that are children of <label>s
    $form.find("span").each(function (i, el) {
      var $e = $(el);
      if ($e.parent().is("label"))
        $e.parent().text($e.parent().text());
    });

    var items = [], itemCount = 0, emptyItems = 0;
    function WriteItems() {
      $e.append($('<div class="row"/>').append(items));
      items = [];
      itemCount = 0;
      emptyItems = 0;
    }

    $form.each(function (i, el) {
      var $item = $('<div class="form-group col-md-3"/>');
      var controls = 0;
      $(el).find(queryString).each(function (i, el) {
        var $thing = $("<" + el.tagName + "/>"), $e = $(el);
        if ($e.is("label") && !$e.text()) {
          if (callback)
            callback();
          return;
        }

        function CopyProp(n) {
          if ($e.prop(n))
            n == "type" ? $thing[0].type = $e.prop(n) : $thing.prop(n, $e.prop(n));
        }
        for (var i in props)
          CopyProp(props[i]);

        if ($e.html()) $thing.html($e.html());
        if ($e.attr("maxlength")) $thing.attr("maxlength", $e.attr("maxlength"));
        if ($e.attr("scs:require") == "y")     $thing.prop("required", true);
        if ($e.attr("scs:accepts") == "email") $thing[0].type = "email";
        if ($e.attr("scs:accepts") == "phone") $thing[0].type = "tel";
        if ($e.attr("scs:accepts") == "date") {
          try { $thing[0].type = "date"; } catch (e) { $thing.attr("type", "date"); }
        }
        if ($e.attr("scs:accepts") == "numeric") {
          $thing.prop("type", "number");
          $thing.attr("min", 0);
        }

        if ($e.is("input, select, textarea")) {
          $thing.addClass("form-control");
          controls++;
          if (controls > 1 && $e.is("select")) {
            var $group = $('<div class="input-group"/>');
            $group.append($item.find("input"));
            $group.append($('<span class="input-group-btn"/>').append($thing));
            $thing = $group;
          }
        }
        if ($e.is("span")) {
          WriteItems();
          itemCount = 4 - 1;
        }

        $item.append($thing);
      });
      itemCount++;
      if (!$item.children().length)
        emptyItems++;
      else
        items.push($item);

      if (itemCount == 4 && emptyItems != 4)
        WriteItems();
    });

    for (var i in xFormData) {
      var $el = $e.find("[name='" + i + "']");
      if ($el.attr("type") == "date") {
        var date = tsToDate(xFormData[i]);
        if (!date)
          continue;
        $el.val(date.toISOString().slice(0, 10));
      } else
        $el.val(xFormData[i]);
    }
    if (callback)
      callback();
  });
}

//******************
//! Global utility functions
//******************
// Uniqueifies the passed jQuery instance.
function setUniqueId($el) {
  if (!$.last_unique_id)
    $.last_unique_id = 0;
  const uniqueID = 'unique-' + $.last_unique_id++
  $el.attr('id', uniqueID);
  return uniqueID
}
// Converts timestamps to Date objects
function tsToDate(t, dateOnly) {
  // If this is an ISO formatted date, strip out the dashes
  t = t.replace(/-/g, "");
  if (!t)
    return null;
  if (t.length > 8 && !dateOnly) {
    var time = Date.UTC(t.substring(0, 4), t.substring(4, 6) - 1,
                        t.substring(6, 8), t.substring(8, 10),
                        t.substring(10, 12), t.substring(12, 14));
    if (isNaN(time)) {
      return null;
    }
    else {
      var date = new Date();
      date.setTime(time);
      return date;
    }
  }
  else
    return new Date(t.substring(0, 4), t.substring(4, 6) - 1,
      t.substring(6, 8));
}
// Converts Date objects or valid javascript date strings to timestamps
function DateToTs(date, dateOnly) {
  if (typeof date === "string") {
    date = new Date(date)
  }
  if (!date)
    return null;
  const out = date.toISOString().replace(/\D/g, "");
  if (dateOnly) {
    return out.substring(0, 8);
  }
  else
    return out;
}
// Converts Date objects to localized strings
function DateToStr(date, dateOnly) {
  var options;
  if (!dateOnly)
    options = { year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric', timeZoneName: 'short' };
  else
    options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString(navigator.language ? navigator.language : "en",
    options);
}
function tsToStr(t, dateOnly) {
  if (t.length == 8)
    dateOnly = true;
  return DateToStr(tsToDate(t, dateOnly), dateOnly);
}
function isoToTs(iso) {
  return iso.replace(/\D/g, "").substring(0, 14);
}
function isoToDate(iso) {
  return tsToDate(isoToTs(iso));
}

/**
 * Formats currency to use locale, handling negative values
 * @param {*} amount - accepts any type valid to the numbe constructor
 * @returns formatted string
 */
function FormatCurrency(amount) {
  amount = Number(amount)
  var formatter = new Intl.NumberFormat(navigator.language ?? navigator.userLanguage, {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(amount.toString());
}

var PluginMimetypes = []; {
  for (var i = 0; i < navigator.plugins.length; i++) {
    for (var j = 0; j < navigator.plugins[i].length; j++) {
      PluginMimetypes.push(navigator.plugins[i][j].type);
    }
  }
}

function parseQueryString( a ) {
  if (a == "") return {};
  var idx = a.indexOf("?");
  var b = {},
  c = a.substr(idx + 1),
  d = c.split("&");
  for (var i = 0; i < d.length; ++i)
  {
    var p=d[i].split('=', 2);
    if (p.length != 2) continue;
    b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
  }
  return b;
}

// Retrieve the QueryString on document initialization. (See README.md.)
(function ($) {
  // Get URL query parameters
  Object.defineProperty($, "QueryString", {
    get: function () {
      return Object.freeze( parseQueryString(window.location.hash) );
    }
  })
})(jQuery);

// Functions to create select lists.
function addOption( node, value, text ) {
  var $node = $( node )
  text = text || value;
  $node.append( $( "<option/>" ).attr( "value", value ).text( text ) );
}

function populateSelectList( node, listObj, addBlank, valueProp, textProp ) {
  addBlank = addBlank || false;
  valueProp = valueProp || "value";
  textProp = textProp || "text";
  $( node ).empty();

  if ( addBlank ) {
    addOption( node, "", "" );
  }
  $.each( listObj, function( i, o ) {
    addOption( node, o[valueProp], o[textProp] );
  } );
}
/*
 * Find an a specific option that has a matching value.  Return the option or
 * null if not found.
 */
function findOptionByValue( $listObj, val ) {
  val = String( val );
  var $options = $listObj.find("option");
  var list = $options.map(function() { return $.trim(this.value) } );
  var index = $.inArray($.trim(val), list);
  return (index != -1) ? $options[index] : null;
}

//******************
//! Global constants
//******************
var APP_URLs = {
  "A": '/cgi-bin/scs_bs/all/spice.pl',
  "T": '/cgi-bin/scs_bs/track/spice.pl',
  "R": '/cgi-bin/scs_bs/reserve/spice.pl',
  "M": '/cgi-bin/scs_bs/oe/spice.pl',
  "E": '/cgi-bin/scs_bs/etear/spice.pl',
};

var CGI_MAP = {
  "main_cgi": 'A',
  "ai_cgi": 'T',
  "track_cgi": 'T',
  "etear_cgi": 'E',
  "res_cgi": 'R',
  "coe_cgi": 'M',
  "adsub_cgi": 'T'
};

// The command map. If a command isn't in here, it's just part of "ALL",
// or for XHRs on the page, it will be assumed to be the page URL.
var COMMAND_MAP = {
  "logout": "A",
  "login_status": "A",
  "get_security_params": "A",
  "get_application_status": "A",
  "user_login": "A",
  "getuserpref": "A",
  "getuserprefjson": "A",
  "saveuserpref": "A",
  "deleteuserpref": "A",
  "getselectlist": "A",
  "edit_adstatus_desc": "T",
  "edit_image_desc": "T",
  "edit_color_desc": "T",
  "edit_pubed_desc": "T",
  "edit_log_desc": "T",
  "list_accounts": "T",
  "databases": "T",
  "setup": "R",
  "adinq": "T",
  "createad": "T",
  "adinfo": "T",
  "ad_notes": "T",
  "view_ad_notes": "T",
  "adimages": "T",
  "viewadimage": "T",
  "reservation": "R",
  "monitoradsub": "T",
  "adsubmit": "T",
  "adsubmitart": "T",
  "orderentry": "M",
  "quickoe": "M",
  "internal_proof": "T",
  "custom_fields": "T",
  "deadline_overrides": "T",
  "etear": "E",
  "etearadinfo": "E",
  "ebill": "M",
  "eteargetproducts": "E",
  "newuserformparams": "A",
};

// Wrapper function to run commands
var CURRENT_URL = APP_URLs['A'];
// `isNavigate` and `alwaysCallback` are special parameters that should ONLY BE USED
// within this file.
function Command(data, callback, isNavigate, alwaysCallback) {
  var method, async, command, cgi;

  if (data instanceof FormData) {
    if (data.entries().next().done)
      throw "No data!";
    method = data.get('method') || 'GET';
    async = data.get('async') || true;
    command = data.get('command') || "";
    cgi = data.get('cgi');
    data.delete('method');
    data.delete('async');
    data.delete('cgi');
  } else {
    if (JSON.stringify(data) == "{}")
      throw "No data!";
    method = data.method || 'GET';
    async = data.async || true;
    command = data.command;
    cgi = data.cgi;
    delete data.method;
    delete data.async;
    delete data.cgi;
  }

  if (!callback)
    callback = function () {};

  var url = CURRENT_URL;
  if (cgi) {
    // A specific CGI is specified, use its URL
    if (cgi in CGI_MAP)
      url = APP_URLs[CGI_MAP[cgi]];
    else if (cgi in APP_URLs)
      url = APP_URLs[cgi];
    else
      url = cgi;
  }
  else if (command in COMMAND_MAP) {
    url = APP_URLs[COMMAND_MAP[command]]
  }
  else if (isNavigate) {
    url = APP_URLs['A']; // Reset if navigating
  }

  if (isNavigate) {
    CURRENT_URL = url; // In case of XHRs
  }

  var params = {
      url: url,
      method: method,
      async: async,
      data: data,
      cache: false
  };
  if (data instanceof FormData) {
    params.processData = false;
    params.contentType = false;
  }
  function onFail (jqXHR, textStatus, errorThrown) {
    console.error("$.ajax failed:", jqXHR, textStatus, errorThrown);
    var msg = !jqXHR.responseText ?
      "Failed to fetch page. If you have an adblocker or a privacy filter, disable it and try again." :
      jqXHR.responseText;
    callback({error: true, Message: msg});
  }
  function onSuccess(reply, err) {
    if ((typeof reply) == "string" && reply.length < 2) {
      // This might cause a logout if the real error is INVALIDSESSION or the like
      Command({command: "get_security_params"});
    }

    var resp;
    if ((typeof reply) == "object") {
      resp = reply;
    } else {
      try { resp = JSON.parse(reply); } catch (e) {}
    }
    if ((typeof resp == "object") && ('WebResponse' in resp))
      resp = resp.WebResponse;
    if (resp == undefined && typeof reply == "string") {
      // Master branch CAS does not return objects for error pages.
      // Check for "re-login" events in this case
      if (reply.match(/<x-exit>(.|\s)*?<\/x-exit>/)) {
        // Parse the resp for the error message to check it
        var regex = /var msg = "(.*?)";/,
            matchs = regex.exec(reply),
            msg = matchs[1];
        if (msg == "ERROR_INVALIDSESSION" ||
            msg == "ERROR_SESSIONTIMEOUT" ||
            msg == "ERROR_REQUIRELOGIN") {
          if (!alwaysCallback) {
            return $("#lLogout").click();
          }
        }
      }
      return callback(reply.replace(/SPICE_PL_URL/g, url));
    }
    else if (resp == undefined)
      return callback(reply);
    if ('Code' in resp && resp.Code != "0") {
      resp.error = resp.Code;
      delete resp.Code;
    }
    if ('Message' in resp && (typeof resp.Message) == "string") {
      if (resp.Message == "ERROR_INVALIDSESSION" ||
          resp.Message == "ERROR_SESSIONTIMEOUT" ||
          resp.Message == "ERROR_REQUIRELOGIN") {
        if (alwaysCallback)
          return callback(resp);
        return $("#lLogout").click();
      } else if (resp.Message.indexOf("ERROR") == 0) {
        resp.error = true;
      } else if (resp.Message == "MSG_GENERIC_SUCCESS") {
        resp.error = false;
        delete resp.Message
      }
    }
    if ((typeof resp == "object") && ('RespObj' in resp))
      resp = resp.RespObj;
    return callback(resp);
  }
  // refactored from .fail and .done because they do not properly handle
  // the html error pages sent back from C.A.S on not logged in
  $.ajax(params).then(onSuccess, onFail);
}

class APIError extends Error {
  constructor(resp) {
    super();
    this.resp = resp;
  }
}

function CommandAsync(data) {
  return new Promise(function (resolve, reject) {
    Command(data, function (res) {
      if (res.error) {
        reject(new APIError(res));
      } else {
        resolve(res);
      }
    })
  })
}

function GetError(resp) {
  return resp?.TranslatedMessage ?? resp?.Message ?? resp
}

function HandleError(resp) {
  $headTitle.text("CAS: Error");
  $("#contentContainer")
    .html('<h1>Could not load page. <i class="fa fa-frown-o"></i></h1>')
    .append("<small><i>Guru Meditation:</i> <code>" + GetError(resp).replace(/<[^>]*>?/gm, '')
    + '</code>.<br><i>UA</i>: <code>' + navigator.userAgent + '</code>');
  $("#contentDimmer").hide();
}

/* Global variable container object, works on a per page basis and will
    store itself within the HashNavigate's History object. */
var __CURRENT_PAGE_GLOBALS = {};
function SetGlobal(objName, obj) {
  __CURRENT_PAGE_GLOBALS[objName] = obj;
}
function GetGlobal(objName) {
  return __CURRENT_PAGE_GLOBALS[objName];
}

const prevHashes = new Set();

// The master navigation function. This is a lot more nuanced and complicated
// than it looks. Be sure that any changes you make are *VERY WELL TESTED*!
var CurrentHash, CurrentPage, $headTitle = $("head title"),
  __HISTORY_PAGE_CONTENT = [],
  HISTORY_IGNORE_PAGES = ["createad", "adsubmit", "quickoe", "account_settings"];
function HashNavigate(rawHash, callback, refresh) {
  if (!rawHash)
    rawHash = "#home";
  if (!refresh && rawHash == CurrentHash)
    return;
  // Hide the navbar if it's expanded
  $("#navbar-button[aria-expanded='true']").click();
  $("#contentDimmer").show();

  // Sets the CurrentHash and makes sure it is what appears in the url bar
  function UpdateCurrentHash(newHash) {
    CurrentHash = newHash;
    if (window.location.hash != CurrentHash)
      window.location.hash = CurrentHash;
  }

  if ($("#contentContainer").length) {
    $("#contentContainer").remove();
  }

  var s = rawHash.split("?");
  var hash = CurrentPage = s[0].substr(1);

  // Some pages like COE have setup code that needs to be run whenever the page is navigated to,
  // but this code is in ES6 modules, and ES6 modules are only executed once, so readding the
  // x-script tags doesn't cause the setup code to be reloaded. This check forces page reload
  // when visiting a previously loaded page.
  //
  // Unfortunately this makes any caching code in this file useless and somewhat reduces
  // the benefit of having a single page app.
  //
  // In the long term, we should probably implement a more full-featured routing framework
  // with navigation guards and route enter/leave hooks. (e.g., see Vue Router for an example of an API)
  //
  // An intermediate option might be to have modules call some function or set some variable to save
  // an enter hook for setup when re-entering a route without a page reload.
  //
  // Until something better is implemented, this seems like the safest solution and the extra reloads
  // are probably bearable because they are not always triggered.
  if (prevHashes.has(hash)) {
    window.location.reload();
    return;
  }
  prevHashes.add(hash);

  var query = s[1];
  if (query)
    query = query.split("&");

  $("#containerWrapper").prepend('<div class="container" id="contentContainer"/>');
  $("#x-script-container").empty();
  $("#x-style-container").empty();
  __CURRENT_PAGE_GLOBALS = {};
  var data = {command: hash};
  for (var i in query) {
    var q = query[i].split('=');
    data[q[0]] = q[1];
  }

  Command(data, function (resp) {
    UpdateCurrentHash(rawHash);
    try {
      if (typeof resp == "object") {
        if (resp.error)
          HandleError(resp);
        if (callback)
          callback(resp);
      } else {
        // Check for master branch error. Used for partial bootstrap implementation
        if (resp.match(/<x-exit>(.|\s)*?<\/x-exit>/)) {
          // Parse the resp for the error message and throw an error with it
          var matches = /var code = "(.*?)";\n  var translatedMsg = "(.*?)";/.exec(resp)
          var code = matches[1] || "";
          var translatedMsg = matches[2] || "";
          throw {code, msg: translatedMsg + " (" + code + ")"};
        }
        // Check for a html tag which means we have an incompatible resp
        if (resp.match(/<html/)) {
          throw "Page incompatible with Bootstrap CAS";
        }
        $("#contentContainer").html(resp);
        // Page title
        var $title = $("#contentContainer x-title");
        if ($title.text())
          $headTitle.text("CAS: " + $title.text());
        else
          $headTitle.text("CAS");
        $title.remove();
        // Custom forms
        var waitingOnCallbacks = 0, afterForms;
        $("#contentContainer [data-custom-form]").each(function (i, el) {
          BuildCustomForm($(el), function () {
            waitingOnCallbacks--;
            if (waitingOnCallbacks == 0)
              afterForms();
          });
          waitingOnCallbacks++;
        });
        afterForms = function () {
          // Toolbar instantiation
          var staticDir = $( "#x-style-container" ).attr( "data-static-dir" ),
              scriptDir = $( "#x-script-container" ).attr( "data-script-dir" );
          $("div.btn-group[data-json]").each(function (i, el) {
            var $e = $(el);
            BuildToolbar($e, JSON.parse($e.attr("data-json")));
            $e.removeAttr("data-json");
          });
          // Tooltips
	        doTooltips("#contentContainer", "bottom");

          // Per-page script execution
          var xscriptcontainer = document.getElementById("x-script-container"),
              waitingOnScriptLoad = 0, loadDependentScripts;
          $("#contentContainer x-script:not([dependent])").each(function (i, el) {
            var $e = $(el), script = document.createElement("script"),
                scriptSrc = $e.attr("src");
            if ($e.attr("type")) {
              script.setAttribute("type", $e.attr("type"));
            }
            if ( $e.attr( "dir" ) == "static" ) {
              script.setAttribute("src", staticDir + "/" + scriptSrc);
            }
            else {
              script.setAttribute("src", scriptDir + "/" + scriptSrc);
            }
            script.onload = function() {
              waitingOnScriptLoad--;
              if (waitingOnScriptLoad == 0)
                loadDependentScripts();
            };
            waitingOnScriptLoad++;
            xscriptcontainer.appendChild(script);
            $e.remove();
          });
          loadDependentScripts = function() {
            $("#contentContainer x-script[dependent]").each(function (i, el) {
              var $e = $(el), script = document.createElement("script"),
                  scriptSrc = $e.attr("src");
              if ($e.attr("type")) {
                script.setAttribute("type", $e.attr("type"));
              }
              if ( $e.attr( "dir" ) == "static" ) {
                script.setAttribute("src", staticDir + "/" + scriptSrc);
              }
              else {
                script.setAttribute("src", scriptDir + "/" + scriptSrc);
              }
              xscriptcontainer.appendChild(script);
              $e.remove();
            });
          }
          if (waitingOnScriptLoad == 0)
            loadDependentScripts();

          // Per-page style sheets
          var xstylecontainer = document.getElementById("x-style-container");
          $("#contentContainer x-style").each(function (i, el) {
            var $e = $(el), styleLink = document.createElement("link");
            styleLink.setAttribute("href", staticDir + "/" + $e.attr("src"));
            styleLink.setAttribute("rel", "stylesheet");
            styleLink.setAttribute("type", "text/css");
            xstylecontainer.appendChild(styleLink);
            $e.remove();
          });

          $("#contentContainer a[data-bs-toggle='popover']").popover(
            {container: '#contentContainer'}).click(function (e) {
              e.preventDefault(); e.stopPropagation(); });
          $("#contentDimmer").hide();

          if (callback)
            callback({});
        };
        if (waitingOnCallbacks == 0)
          afterForms();

        // Clear
        if (CASWebSocket && CASWebSocket.isOpen()) {
          CASWebSocket.clearCallbacks();
        }
        else {
          createNewCASWebSocket();
        }
      }
    } catch (e) {
      if(e.code === '40') { // error not logged in
        const searchParams =new URLSearchParams( window.location.hash.slice( window.location.hash.indexOf( "?" ) + 1 ))
        if (searchParams.get("login") && searchParams.get("logintoken")) {
          Command({command: "user_login", login: searchParams.get("login"), logintoken: searchParams.get("logintoken")}, (resp) => {
            if (resp.error) {
              $("#contentDimmer").hide()
              alertM("The url includes an invalid auto-login credential. Please log in with username and password.", "Invalid Auto-Login")
            }
            else {
              // remove the login search params and reload the page
              searchParams.delete("login")
              searchParams.delete("logintoken")
              window.location = window.location.origin + window.location.pathname + window.location.hash.slice(0, window.location.hash.indexOf("?") + 1) + searchParams.toString()
              window.location.reload()
            }
          }, false, true)
        }
      }
      else {
        $("#contentDimmer").hide();
      }
      HandleError( typeof e == "string" ? e : e.msg );
      $("#contentContainer a[data-bs-toggle='popover']").popover();
      if (callback)
        callback({error: e.code, TranslatedMessage: e.msg.toString()});
    }
  }, true, true);
}

function doTooltips(containerSelector, defaultPosition, tooltipContainerSelector) {
  if (helpJSON) {
    const $helpElements = $(containerSelector).find("[data-help]")
    for (let i = 0; i < $helpElements.length; i++) {
      const $el = $($helpElements[i])
      $el.attr("title", helpJSON[$el.attr("data-help")])
    }
  }
  $(containerSelector + " [title]").each(function (i, el) {
    var $e = $(el);
    if ($e.attr("data-original-title") !== undefined) {
      // This already has a tooltip or a popover (possibly popup help).
      return;
    }
    if ($e.attr("data-bs-toggle")) {
      console.warn("Could not tooltip the following element, as it " +
	"already had a 'data-bs-toggle' attribute:", el);
      return;
    }
    const multiLine = $e.attr("title").includes("\\n")
    const title = $e.attr("title").replaceAll("\\n", "\n")
	  const position = $e.attr('title-position') ?? defaultPosition ?? 'top';
    $e.removeAttr("title");
    $e.removeAttr('title-position');

    let trigger = "hover focus click"
    // don't want buttons (or links acting as buttons with btn class) to retain tooltip onclick
    if (($e.prop("tagName") === "BUTTON") || $e.hasClass("btn")) {
      trigger = "hover"
    }
    // if the help tag includes \n, this is a multiline help tag. Allow any size and don't wrap white space
    $e.tooltip({trigger, title, placement: position, container: tooltipContainerSelector ? $e.parents(tooltipContainerSelector) : $e.parent().parent(), template: `<div class="tooltip" role="tooltip" ${multiLine ? 'style="white-space: pre"' : ""}><div class="arrow"></div><div ${multiLine ? 'style="max-width: none"' : ""} class="tooltip-inner"></div></div>`});
  });
}

function RefreshPage(callback) {
  HashNavigate(window.location.hash, callback, true);
}

// Form submission via AJAX
function FormAsObject(formSelector, ignoreEmpty) {
  // This is probably a bad idea. But it works, and using FormData didn't,
  // so I have no regrets. -acavalier
  ignoreEmpty = (ignoreEmpty !== false);
  var data = {};
  $(formSelector).serializeArray().map(function (x) {
    if (ignoreEmpty && !x.value && (x.value !== false))
      return;
    data[x.name] = x.value;
  });
  return data;
}

function PopulateForm(formSelector, data) {
	$(formSelector).each(el => {
		if (data.hasOwnProperty(el.name)) {
			el.value = data[el.name];
		}
	});
}

function ValidateForm(formSelector, ignoreEmpty) {
  var $form = $(formSelector);
  if (!$form[0].checkValidity()) {
    // Fake a submit click so the validation messages are displayed to the user
    $('<input type="submit">').hide().appendTo($form).click().remove();
    return false;
  }
  return true;
}

function SubmitForm(formSelector, ignoreEmpty, callback) {
  var $form = $(formSelector);
  if (!ValidateForm(formSelector)) {
    return;
  }

  var data = FormAsObject(formSelector, ignoreEmpty);
  data['form_id'] = $form.attr("id");
  Command(data, function (resp) {
    if (callback)
      callback(resp);
  });
}

var SECURITY_PARAMS = {};

function UpdateSecurityParams(callback) {
  Command({command: "get_security_params", "sendsecurityparams": true}, async function (resp) {
    SECURITY_PARAMS = resp;
    if (!resp.Response)
      resp.error = resp.error || true;
    if (resp.error) {
      callback(resp);
      return;
    }
    if (resp.FullUserName && resp.FullUserName != "") {
      $("a#accountmenu").text(resp.FullUserName);
    }
    else {
      const el =  $("a#accountmenu").parent()
      el.html('<a class="nav-link">Click Here to Login</a>');
      el.click(showLoginOverlay)
    }
    UpdateApplicationStatus();
    if ( callback )
      await callback( { UseKeyboardShortcuts: resp.UseKeyboardShortcuts } );
  }, false, true);
}

function getSecurityParams() {
  return SECURITY_PARAMS.WebSecurity;
}

function getCASUserId() {
  return SECURITY_PARAMS.UserName;
}

function isRoot() { return SECURITY_PARAMS.AdminLevel == 0 }
function isAdmin() { return SECURITY_PARAMS.AdminLevel == 1 }
function isSalesperson() { return SECURITY_PARAMS.AdminLevel == 2 }
function isAdvertiser() { return SECURITY_PARAMS.AdminLevel == 3 }
function isAdvertiserSales() { return SECURITY_PARAMS.AdminLevel == 4 }
function isGuest() { return ( ( SECURITY_PARAMS.AdminLevel < 0 ) ||
                              ( SECURITY_PARAMS.AdminLevel > 4 ) ) }

var APPS_STATUS = {};

function UpdateApplicationStatus() {
  Command({command: "get_application_status"}, function (resp) {
    if (!resp.Response)
      resp.error = resp.error || true;
    if (resp.error)
      return;

    const roleCheckers = {
      root: isRoot,
      admin: isAdmin,
      sales: isSalesperson,
      advertiser: isAdvertiser,
      advertisersls: isAdvertiserSales
    };

    $("li").removeAttr("style");

    function addShortcutMark($elem) {
      if (!SECURITY_PARAMS.UseKeyboardShortcuts) {
        return
      }
      const shortcut = $elem.attr("data-shortcut")
      const text = $elem.prop("innerText")
      if (!shortcut || !text) {
        return
      }
      let foundIndex = text.indexOf(shortcut) // direct indexOf with capitalization
      if (foundIndex === -1) { // if that failed, look regardless of capitalization
        foundIndex = text.toLowerCase().indexOf(shortcut.toLowerCase())
      }
      if (foundIndex !== -1) {
        $elem.html(`<span>${text.slice(0, foundIndex).replaceAll(" ", "&nbsp;")}</span><span style='text-decoration: underline'>${text[foundIndex]}</span><span>${text.slice(foundIndex + 1).replaceAll(" ", "&nbsp;")}</span>`)
      }
      else {
        $elem.text(`${text} (${shortcut})`)
      }
    }

    $("#navbar .nav-item").each(function () {
      const $menuItem = $(this);
      const $link = $menuItem.children("a");
      const allowedRoles = $link.attr("data-user-types") ? $link.attr("data-user-types").split(" ") : [];

      if (allowedRoles.some(role => roleCheckers[role] && roleCheckers[role]()) && allowedRoles.length > 0) {
        $link.removeClass("hidden");
        addShortcutMark($link)
      }
      else if (allowedRoles.some(role => roleCheckers[role] && !roleCheckers[role]()) && allowedRoles.length > 0) {
        $link.addClass("hidden");
      }
      $menuItem.find("li").each(function () {
        const $subMenuItem = $(this);
        const $subLink = $subMenuItem.children("a");
        const allowedRoles = $subLink.attr("data-user-types") ? $subLink.attr("data-user-types").split(" ") : [];
        if (allowedRoles.some(role => roleCheckers[role] && roleCheckers[role]()) && allowedRoles.length > 0) {
          $subLink.removeClass("hidden");
        }
        else {
          if (allowedRoles.some(role => roleCheckers[role] && !roleCheckers[role]()) && allowedRoles.length > 0) {
            $subLink.addClass("hidden");
          }
        }
      });
    });

    $("#lLogin").toggleClass('hidden', !isGuest());
    if ( isGuest() ) {
      $("#navbar ul.navbar-nav > li").each(function () {
        const $menuItem = $(this);
        const $link = $menuItem.children("a");
        if ($link.attr("data-login-status") === "not required") {
            $link.removeClass("hidden");
        }
        $menuItem.find("li").each(function () {
          const $subMenuItem = $(this);
          const $subLink = $subMenuItem.children("a");
          if ($subLink.attr("data-login-status") === "not required") {
              $subLink.removeClass("hidden");
          }
          else {
            if ($subLink.attr("data-login-status") === "logged in" ) {
              $subLink.addClass("hidden");
            }
          }
        });
      });
      $("#account-menu-dropdown").removeClass("hidden")
      $("#lLogout").addClass("hidden")
      $("#lAccountSettings").addClass("hidden")
    }

    APPS_STATUS = JSON.parse(resp["WebApps"]);

    // Hide all menu items for non-active apps. Also hide apps that do not configured to allow guests.
    var selector = "#navbar a[data-app]:not([data-app='WEB'])"
    for (var i in APPS_STATUS) {
      if (APPS_STATUS[i].Active != "T") continue;
      if (isGuest() && APPS_STATUS[i].Guest != "T") continue;
      selector += ":not([data-app='" + APPS_STATUS[i].AppID.toUpperCase() + "'])";
    }
    if ( $(selector) ) { 
      $(selector).each( function( i, o ) {
        $(o).addClass('hidden');
      });
    }

    var securityGroups = getSecurityParams();
    var selector = "#navbar a[data-security-groups!='']";
    if ( $(selector) ) {
      $(selector).each( function( i, o ) {
      	var securityArray = null;
        var dataSecurityGroups = $(o).attr('data-security-groups');
        if ( dataSecurityGroups ) {
          securityArray = dataSecurityGroups.split(',');
        }

        var itemFound = false;
        if ( securityArray ) {
          for ( var j = 0 ; j < securityArray.length ; j++ ) {
            if ( securityGroups[ securityArray[ j ] ] ) {
              itemFound = true;
              break;
            }
          }

          if ( !itemFound ) {
            $(o).addClass('hidden');
          }
        }
      } );
    }

    // Hide all menus that are now empty, except for the "account menu dropdown" (this is an empty list for guest users, just login button)
    $("#navbar li.dropdown, #navbar li.dropdown-submenu").each(function (i) {
      var $el = $(this);
      if (($el.find("a[href]:not(.hidden)").length == 0) && ($el.attr("id") !== "account-menu-dropdown")) {
        $el.addClass("hidden");
      }
      else {
        addShortcutMark($el.children("a"))
      }
    });

    $("#navbar ul.dropdown-menu").each(function (i) {
      var $el = $(this);
      if ($el.find("a[href]:not(.hidden)").length == 0) {
        $el.addClass("hidden");
      }
      else {
        addShortcutMark($el.children("a"))
      }
    });

    $("#navbar li.dropdown").each(function (i) {
      var $el = $(this);
      if (($el.find("a.dropdown-item:not(.hidden)").length == 0) && ($el.attr("id") !== "account-menu-dropdown")) {
        $el.addClass("hidden");
      }
      else {
        addShortcutMark($el.children("a"))
      }
    });
    $(".scswatermark").show();
    $(".navbar-nav .dropdown-item").each(function (i) {
      var $el = $(this)
      if ($el.parent().find(".submenu").length > 0) {
        $el.on("click", function (evt)  {
          // prevent closing menu
          evt.preventDefault()
          evt.stopPropagation()

          const submenu = $el.parent().children(".submenu")
          const open = submenu.css("display") === "block"
          $(".submenu").css("display", "none").removeClass("show") // close all submenus
          submenu.parents("li").children(".submenu").css("display", "block").addClass("show") // open all submenu ancestors of this submenu
          submenu.css("display", open ? "none" : "block") // toggle display of this submenu
          if (open) {
            submenu.css("display", "none").removeClass("show")
          }
          else {
            submenu.css("display", "block").addClass("show")
          }
        })
      }
      else {
        $el.on("click", function (evt)  {
          $(".submenu").css("display", "none").removeClass("show") 
        })
      }
    })
    $(".navbar-nav .dropdown-toggle").click(()=> { // close all submenus when initially opening a menu
      $(".submenu").css("display", "none")
    })
  });
};

// Change Active flag in APPS_STATUS when
// the value is changed.
function appToggleActive(appID) {
  var index = APPS_STATUS.findIndex(x => x.AppID == appID );
  if (index >= 0) {
    APPS_STATUS[index].Active = APPS_STATUS[index].Active == 'F'? 'T': 'F';
  }
}

function appIsActive(appID) {
  var index = APPS_STATUS.findIndex(x => x.AppID == appID );
  if (index >= 0) {
    return APPS_STATUS[index].Active == 'T';
  }
  return false;
};

// Compatiblity functions for migration from master
function postJSON( command, callback, params ) {
  if ( !params ) {
    params = {};
  }
  params["command"] = command;
  params["method"] = "POST";

  return Command( params, callback );
}

function constructURL( command, obj, spicePlDir, fakeFileName ) {
  if ( isUndefinedOrNull( obj ) ) { obj = {}; }
  if ( isUndefinedOrNull( spicePlDir ) ) { spicePlDir = ""; }
  if ( isUndefinedOrNull( fakeFileName ) ) { fakeFileName = ""; }

  var allKeys, allVals, spicePl, url;

  if ( spicePlDir != "" ) {
    spicePlDir += "/";
  }

  if ( fakeFileName != "" ) {
    spicePl = "spice.pl/" + fakeFileName + "?";
  }
  else {
    spicePl = "spice.pl?";
  }

  obj["command"] = command;
  url = spicePlDir + spicePl + $.param( obj );

  return url;
}

var CASWebSocket;
function createNewCASWebSocket() {
  if (CASWebSocket)
    CASWebSocket.close();
  var session_id = getSecurityParams().SessionId;

  var timeout = function() {
    $("#lLogout").click();
    setTimeout(function(){$("#overlayStatus").text('Session Timed Out.');}, 500);
  };

  // initialize a new MoaiWebSocket instance
  CASWebSocket = new MoaiWebSocket({"session_id": session_id}, function(resp) {
    if (resp.Status == "ERROR_SESSIONTIMEOUT") {
      timeout();
    }
    // Do nothing if a display exists already
    else if ($("#extendsession").length) {
      return;
    }
    else if (resp.Status == "ERROR_SESSIONABOUTTOEXPIRE") {
      // Prepare to display a notification
      var timeRemaining = tsToDate(resp.TimeRemaining) - (new Date()),
          seconds = (timeRemaining / 1000).toFixed(),
          $div = $("<div>Your web session is about to expire in <span/> seconds</div>"),
          $button = $('<button class="btn btn-danger" id="extendsession">Extend Session</button>');
      $div.append("<br/>", $button);
      // Set delayed timeouts up to log out when it expires
      var sessionTimeoutHandler = setTimeout(timeout, timeRemaining);

      $button.click(function() {
        // Button extends the session and clears timeouts
        Command({"command": "extend_session"}, function(resp) {
          if (!resp.Response)
            timeout();
          clearTimeout(sessionTimeoutHandler);
          $button.parents("#alert-box").find("a.close").click();
        });
      });

      // Display the warning and decrement the timer over time
      notify($div, "warning", true, 0, false);
      var updateDisplay = function() {
        var $display = $div.find("span:visible")
        // Only do so if it is still visible
        if ($display) {
          seconds -= 1;
          $display.html(seconds);
          if (seconds > 0)
            setTimeout(updateDisplay, 1000);
        }
      };
      updateDisplay();
    }
  }, false);
}

function getURLParam( name ) {
  var val = "";
  window.location.href.replace( /.*\?/g, "" ).split( "&" ).forEach( function ( p ) {
    if ( p.split( "=" )[ 0 ] == name ) {
      val = p.split( "=" )[ 1 ];
    }
  } );
  return val;
}

function makeMap( list, keyProp ) {
  var mapObj = {};
  list.forEach(function(i) {
    // Force a string
    var key = i[keyProp] + "";
    mapObj[key] = i;
  });
  return mapObj;
}

function downloadURL( url, filename ) {
  var $link = $('<a></a>').attr({'href': url, 'download': filename});
  $link[0].click();
}

function showLoginOverlay() {
  $("#contentContainer").empty();
  $("#alert-window").empty();
  $("#x-script-container").empty();
  $("#loginControls").show();
  $("#overlayStatus").text("");
  $("#loginOverlay").fadeIn("medium");
}

function NavigateTo(hash, refresh) {
  HashNavigate(hash, function (resp) {
    if (resp.error) {
      $("#overlayStatus").text("Could not load page: " + resp.TranslatedMessage);
    } else if ($("#loginOverlay").is(":visible")) {
      $("#loginOverlay").fadeOut("medium");
    }
  }, refresh);
}

function logout( e ) {
  e.preventDefault();

  if ( CASWebSocket ) {
    CASWebSocket.close();
  }
  Command( { command: 'logout' }, async function ( resp ) {
    if ( resp.error && resp.Message != "ERROR_INVALIDSESSION" &&
        resp.Message != "ERROR_SESSIONTIMEOUT" &&
        resp.Message != "ERROR_REQUIRELOGIN" ) {
      return alertM( "Error logging out: " + GetError( resp ) );
    }
    CURRENT_URL = APP_URLs['A'];
    Command( { command: "new_session"}, function ( resp ) {
      CurrentHash = '';
      __HISTORY_PAGE_CONTENT = __HISTORY_PAGE_CONTENT.filter( function ( itm, i ) {
        itm.$page.remove();
        itm.$page.empty();
        return false;
      });
      UpdateSecurityParams();
      showLoginOverlay();
    });
  }, false, true );
}

// "onload"
$(function () {
  // Bootstrap Plugins & events init
  $(window).bind('hashchange', function (e) {
    e.preventDefault();
    if ($("#loginOverlay").is(":visible")) {
      $("#overlayStatus").text('');
    }
    NavigateTo(window.location.hash);
  });
  $(document).on('submit', function (e) {
    e.preventDefault();
    return false;
  });

  // Focus ring remover
  var rrKeyDown, rrMouseDown;
  rrKeyDown = function () {
    $("#ringRemover").html("");
    $(document).unbind('keydown');
    $(document).on('mousedown', rrMouseDown);
  };
  rrMouseDown = function () {
    $("#ringRemover").html(":focus{outline:none!important}");
    $(document).unbind('mousedown');
    $(document).on('keydown', rrKeyDown);
  };
  rrMouseDown();

  // UI reset
  $("#username").focus();

  // Start page event handlers
  $(".osscredits").click(function (e) {
    e.preventDefault();
    var staticDir = $( "#x-style-container" ).attr( "data-static-dir" );
    $.ajax({
      url: staticDir + "/oss_credits.html"
    }).done(function (data) {
      alertM(data, "Open source credits", true);
    });
  });

  // load help tags
  Command({command: "loadwebhelpjson", method: "POST"}, (resp) => {
    if (resp && resp.help && resp.help != "null") {
      helpJSON = JSON.parse(resp.help)
    }
  }, false, true)

  // Advance/submit on 'enter' key
  $('#username').keypress(function (e) {
	  if ((e.keyCode ? e.keyCode : e.which) == '13')
	    $("#password").focus();
  });
  $('#password').keypress(function (e) {
	  if ((e.keyCode ? e.keyCode : e.which) == '13')
	    $("#btnLogin").click();
  });
  $("#btnLogin").click(function (e) {
    $("#overlayStatus").text('');
    $("#loginError").text("")

    if($("#username").val() === "") {
      $("#loginError").text("Please provide a username.")
      return
    }

    if($("#password").val() === "") {
      $("#loginError").text("Please provide a password.")
      return
    }
    const stopLoading = startLoadingButton("#btnLogin")

    Command({ method: 'POST', command: 'user_login', login: $("#username").val(),
        password: $("#password").val(), OTP: $("#OTP").val() }, function (resp) {
      stopLoading()
      if (!resp.error || resp.Message == "ERROR_REQUIRELOGOUT") {
        $("#loginControls").hide();
        $("#password").val('');
        $("#loginControls").removeClass('has-error');
        UpdateSecurityParams(function (resp) {
          if (resp.error)
            return console.error(resp);
          if ($.QueryString.redirect) {
            window.location.href = $.QueryString.redirect;
            window.location.reload();
          } else {
            // TODO: if we could use HashNavigate that might be nicer, but it didn't seem to work
            // right with the tables at least in ebill.
            window.location.reload();
          }
        });
      } else {
        if (resp.Message == "ERROR_INVALIDUSERIDORPASS") {
          $("#loginControls").addClass("has-error");
          $("#loginError").text("Invalid Login.")
          $("#password").val('');
        }
        else if (resp.Message == "ERROR_SESSIONTIMEOUT" ||
                 resp.Message == "ERROR_INVALIDSESSION") {
          Command({command: "new_session"}, function (resp) {
            if (resp.error) {
              $("#overlayStatus").text(
                "Error creating a new session. Please contact a server administrator.");
            } else
              $("#btnLogin").click();
          });
          return;
        }
        else if (resp.Message == "ERROR_REQUIRESOTP") {
          alertM("Please enter your OTP code sent to your account's authentification method.", "Two-factor authentication", true);
          $("#OTP").show();
          $("#OTP").focus();
        }
        else
          alertM(GetError(resp), "Error logging in", true);
      }
    });
  });
  $("#ssoSignIn").click(function() {
    var params = {
      "command": "sso_start_sign_in",
      "method": "POST",
      "RelayState": window.location.href
    };
    Command(params, function(resp) {
      document.getElementById("loginError").innerText = ""
      if (resp.reditrect) {
        window.location = resp.redirect;
      }
      else {
        document.getElementById("loginError").innerText = "Error logging in with SSO."
      }
    });
  });
  $("#returnHomeButton").click(function() {
    window.location = "/cgi-bin/scs/all/spice.pl?command=home";
  })
  $("#forgotPasswordButton").click(function() {
    NavigateTo("#forgot", true);
  })
  $("#newAccountButton").click(function() {
    NavigateTo("#newuser", true);
  })
  $("#lLogout").click(logout);
  $("#lLogin").click(showLoginOverlay);

  // Check the status of our session
  UpdateSecurityParams(function (resp) {
    if (resp.error || resp.AdminLevel == -1) {
      Command({command: "new_session"}, function (resp) {
        if (!resp.error) {
          if ( window.location.href.includes( "request_code" ) )
            window.open( window.location.href );
          $("#loginControls").show();
          return;
        }
        $("#overlayStatus").text(
          "Error creating a new session. Please contact a server administrator.");
      });
    } else {
      if (resp.UseKeyboardShortcuts) {
        addKeyboardShortcutListener()
      }
      HashNavigate(window.location.hash, function (resp) {
        if (resp.error) {
          if (Number(resp.error) === 40) { // not logged in - show login controls
            $("#loginControls").show()
          }
          else {
            $("#overlayStatus").text(
              "Could not load page: " + resp.TranslatedMessage);
          }
        } else {
          $("#loginOverlay").fadeOut("medium");
        }
      });
    }
  });
});

function addKeyboardShortcutListener() {
  let lastClickedElements = []
  document.addEventListener('keydown', (evt) => {
    if (document.activeElement.nodeName === "BODY") { // only look for keyboard navigation if we are not focused on anything else
      if (evt.key === "Escape") { // escape from current menu level
        if (lastClickedElements.length) {
          lastClickedElements.pop().click()
        }
      }
      else {
        const shortcut = evt.key.toUpperCase()
        // see if there are any nav items with this shortcut, return if not
        const potentialMatches = Array.from(document.querySelectorAll(`[data-shortcut="${shortcut}"]`))
        if (potentialMatches.length === 0) {
          return
        }
        const level = document.getElementById("navbar").querySelectorAll('.show:not(.nav-link)').length
        let clickElement
        if (level === 0) { // if no menus are open, look for a top level menu item to click
          clickElement = potentialMatches.find(match => match.classList.contains("nav-link"))
        }
        else { // otherwise search for a match with the correct menu level
          for(const potentialMatch of potentialMatches) {
            let parent = potentialMatch
            let matchLevel = 0
            let allLevel = 0
            while (parent = parent.parentElement) {
              if (parent.classList.contains("show")) {
                matchLevel++
              }
              allLevel ++
            }
            if ((matchLevel === level) && (allLevel === ((matchLevel * 2) + 8))) {
              clickElement = potentialMatch
              break
            }
          }
        }
        if (clickElement) {
          clickElement.click()
          lastClickedElements.push(clickElement)
        }
      }
    }
  })
}